// src/config.js
// Load env vars at runtime
export const config = {
  tenantId: process.env.TENANT_ID || "e1dc7651-6962-4791-89fd-3d0ced5a4775",
  frontendClientId: process.env.FRONTEND_CLIENT_ID || "8e098cdd-323f-4bed-8649-7e8708644667",
  incidentClientId: process.env.INCIDENT_CLIENT_ID || "aeb6aa6a-1630-43b4-b2b9-2b31c39508b8",
  authClientId: process.env.AUTH_CLIENT_ID || "bd33a161-4c3c-47e5-925b-2e616ad9d475",
  apiUrl: process.env.REACT_APP_API_URL || "http://localhost:9090",
  b2cUserFlowName: process.env.B2C_USER_FLOW_NAME || "SignupIncidentAi",
  b2cTenantName: process.env.TENANT_NAME || "incidentaib2c",
  redirectUri : process.env.REDIRECTURI || "http://localhost:3001"
};

console.log("📋 Config loaded:", config);